export const INTERNAL_API_KEY_CONSTANTS = {
  HIGHLIGHT_SOURCE_LOOKUP: 'highlight-source-lookup',
  REVIEW_SESSION_SOURCE_MULTI_LOOKUP: 'REVIEW_SESSION_SOURCE_MULTI_LOOKUP'
}
